export default __webpack_public_path__ + "77b260f8540a302ad0b4f9a896462ee1.svg";